<template>
    <div class="delivery-content-inner text-white">
        <h1 v-if="title" class="text-size1 leading-spc2 font-medium mb-spc26">
            {{title}}
        </h1>
        <p v-if="desc" class="text-size2 leading-spc4 opacity-80 mb-spc27">
            {{desc}}
        </p>
        <ThemeButton :title="btntitle" :url="btnurl" className="theme-border-btn opacity-90 border-solid" />
    </div>
</template>

<script>
    import ThemeButton from "../../../common/ThemeButton";

    export default {
        name: "Delivery",
        props:['title', 'desc', 'btntitle', 'btnurl'],
        components: {
            ThemeButton
        },
    }
</script>

<style scoped>

</style>